module.exports = __webpack_public_path__ + "img/left1.9bccb3f7.png";